import Image from "next/image";
import styled from "styled-components";

const Frame = styled.div`
	width: 100%;
	min-width: 0;
`;

export default function AtmosphereImage() {
	return (
		<Frame>
			<Image
				unoptimized
				src="/assets/generated/hero_atmosphere.png?v=7"
				alt="Labeled savings boxes for Camera, House, Trip, Tires, and Gift"
				width={1600}
				height={900}
				style={{
					width: "100%",
					height: "auto",
					filter: "drop-shadow(0 22px 26px rgba(40, 32, 40, 0.18))"
				}}
			/>
		</Frame>
	);
}
